import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html'
})
export class DashboardPage {
  headerData: any;
  constructor(
    public navCtrl: NavController,
    public events: Events
  ) {
    this.headerData = { title: 'TSE Instructor Certification System' };
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts